require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./coding-interview-prep-project-euler-problem-144-investigating-multiple-reflections-of-a-laser-beam.json") })
        }
      }, "path---coding-interview-prep-project-euler-problem-144-investigating-multiple-reflections-of-a-laser-beam");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---coding-interview-prep-project-euler-problem-144-investigating-multiple-reflections-of-a-laser-beam!./.cache/json/coding-interview-prep-project-euler-problem-144-investigating-multiple-reflections-of-a-laser-beam.json
// module id = 1398
// module chunks = 231608221292675